"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectFactory = void 0;
class SubjectFactory {
    static defaultSubject() {
        return {
            id: 'subject-id',
            name: 'Spanish',
            links: {},
        };
    }
}
exports.SubjectFactory = SubjectFactory;
SubjectFactory.sample = (subject) => ({
    ...SubjectFactory.defaultSubject(),
    ...subject,
});
//# sourceMappingURL=SubjectsFactory.js.map